// extracted by mini-css-extract-plugin
module.exports = {"columns-3":"1700","columns-2":"1550","columns-1":"1350","passwordInput":"NewPasswordModal_passwordInput__ptMZ0","tooltipIcon":"NewPasswordModal_tooltipIcon__uLvSA"};